import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { Features } from './components/Features';
import { Showcase } from './components/Showcase';
import { HowItWorks } from './components/HowItWorks';
import { Testimonials } from './components/Testimonials';
import { VoicePreview } from './components/VoicePreview';
import { Footer } from './components/Footer';

function App() {
  useEffect(() => {
    // Initialize Botpress WebChat
    const script1 = document.createElement('script');
    script1.src = 'https://cdn.botpress.cloud/webchat/v2.2/inject.js';
    script1.async = true;
    document.body.appendChild(script1);

    const script2 = document.createElement('script');
    script2.src = 'https://files.bpcontent.cloud/2025/01/20/13/20250120130618-8TXOZF8B.js';
    script2.async = true;
    document.body.appendChild(script2);

    return () => {
      document.body.removeChild(script1);
      document.body.removeChild(script2);
    };
  }, []);

  return (
    <div className="min-h-screen bg-gray-900">
      <Hero />
      <Features />
      <Showcase />
      <HowItWorks />
      <Testimonials />
      <VoicePreview />
      <Footer />
    </div>
  );
}

export default App;